"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIframePath = getIframePath;
exports.IFramePaths = void 0;
var IFramePaths;
exports.IFramePaths = IFramePaths;

(function (IFramePaths) {
  IFramePaths["Base"] = "/iframe/:id";
  IFramePaths["Widget"] = "/widget/live/:id";
  IFramePaths["WidgetResults"] = "/widget-result/get";
})(IFramePaths || (exports.IFramePaths = IFramePaths = {}));

function getIframePath(id) {
  return '/iframe/' + id;
}